import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { SecurityDataService } from './security-data.service';
import { RoutingDataService } from './routing-data.service';

/**
 * Controlla i permessi sulle singole routes
 */
@Injectable()
export class AuthorizationVerifierService{

  constructor(
    private _securityDataService: SecurityDataService,
    private _routingDataService: RoutingDataService,
    private _router: Router) 
  { }

  public check = async(routerStateSnapshot:RouterStateSnapshot):Promise<boolean> =>{
    this._debug('canActivate()', 'state.url', routerStateSnapshot.url, true)

    const requiredAuthorities = this._routingDataService.getCurrentRoutingNode().requiredAuthorities;
    const isAuthorized = this._securityDataService.isAuthorized(requiredAuthorities)

    if(!isAuthorized){
      this._debug('_check()', 'STATO', '[Non autorizzato]')
      this._router.navigate([
        'error'
      ],
      { queryParams: 
        {
          status: 403,
          message: 'Accesso non autorizzato'
        } 
      })
      return false;
    }
    else {
      this._debug('_check()', 'STATO', '[Autorizzato]')

      return true;
    }
  }

  private _debug = (func, key, value, primary?: boolean) => {
    let color, background;
    if(primary){
      color = 'white';
      background = 'orange';
    }else{
      color = 'black';
      background = 'transparent';
    }
    console.log(`%c AuthorizationVerifierService.${func} - ${key}: ${value}`, `background: ${background}; color: ${color}; border:2px solid orange; padding: 2px;`);
  }
}